export const decimalToHex = (decimal: number) => {
  return "0x" + decimal.toString(16)
}
